
export enum EnvelopeKind {
  LoanDocs = 'loan_docs',
  LoanModification = 'loan_modification',
  OwnersRelease = 'owners_release'
}

type EnvelopeSectionConfig = {
  kind: EnvelopeKind
  label: string
}

export const ENVELOPE_SECTIONS: EnvelopeSectionConfig[] = [
  { kind: EnvelopeKind.LoanDocs, label: 'Loan Documents' },
  { kind: EnvelopeKind.OwnersRelease, label: "Owner's Release" },
  { kind: EnvelopeKind.LoanModification, label: 'Loan Modification' },
]

export type EnvelopeRecord = {
  envelopeId: string
  timestamp: Date
  status: undefined | 'sent' | 'voided' | 'customer-signed' | 'draft'
  kind: EnvelopeKind
}

export enum DocusignRecipientRole {
  PrimaryBorrower = 'Primary Borrower',
  CoBorrower = 'CoBorrower',
  Spouse = 'Spouse',
  LoanOfficer = 'Loan Officer',
  Owner1 = 'Owner 1',
  Owner2 = 'Owner 2',
  Owner3 = 'Owner 3',
  Owner4 = 'Owner 4',
}

export const OWNER_RECIPIENT_ROLES: DocusignRecipientRole[] = [
  DocusignRecipientRole.Owner1,
  DocusignRecipientRole.Owner2,
  DocusignRecipientRole.Owner3,
  DocusignRecipientRole.Owner4,
]

export const getDocusignErrorDetails = (ex: unknown): { errorCode?: string; message?: string } => {
  const err = ex as {
    message?: string
    response?: {
      body?: { errorCode?: string; message?: string }
      data?: { errorCode?: string; message?: string }
    }
  }
  const body = err.response?.body ?? err.response?.data
  return {
    errorCode: body?.errorCode,
    message: body?.message ?? err.message,
  }
}

export const formatted = (num: number | bigint | string, digits = 2): string => {
  let _num = num
  if (typeof _num === 'string') {
    _num = parseFloat(_num.replace(/[^0-9.]/g, ''))
  }

  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: digits,
    minimumFractionDigits: digits
  }).format(_num)
}